import { render } from "./LIconPosteLivraison.vue?vue&type=template&id=0e072505"
import script from "./LIconPosteLivraison.vue?vue&type=script&lang=js"
export * from "./LIconPosteLivraison.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__